import { createFileRoute } from "@tanstack/react-router";
import { CustomEntityKanbanRedirectPage } from "~/pages/CustomEntityKanbanRedirectPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/details/$id/kanban")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, datasetSlug } = Route.useParams();
  return <CustomEntityKanbanRedirectPage id={id} datasetSlug={datasetSlug} />;
}
